import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import Lottie from "lottie-react";
import { Link, Redirect } from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import booster from '../../assets/img/people/booster.svg'
import filter from '../../assets/img/people/filter.svg'
import peoplelocation from '../../assets/img/icons/peoplelocation.svg'
import people from '../../assets/json/people.json'
import Filter from '../commoncomponents/filter';
import BoostPlan from '../commoncomponents/boostplan';
import BoostActivate from '../commoncomponents/boostactivate';
import BoostPaymentPlan from '../commoncomponents/boostpaymentplan';
import Join from './plan/join';
import axios from 'axios';
import ls from "local-storage";
import PaymentPending from '../main/plan/paymentpending';
import revert from '../../assets/img/revert.svg'
import boost from '../../assets/img/boost.svg'
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class People extends Component {

    constructor(props) {
        super(props);
        this.resetusers = this.resetusers.bind(this);
        this.state = {
            filtermodal: false,
            premiummodal: false,
            boostplanmodal: false,
            boostactivatemodal: false,
            boostpaymentplanmodal: false,
            langKey: ls.get('LangValue'),
            api_url:localStorage.getItem('api_url'),
            user_details: '',
            matches: '',
            paymentpendingmodal: false,
            activatedBoostModel: false,
            currentSlideIndex: 0,
            totalSlides: '',
            showNoDataPrev: false,
            showNoDataNext: false,
            peopleDetails: [],
            resetplanmodal: false,
            reset_count: '',
            nofoundmodal: false,
            reset_msg: '',
        };
    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        localStorage.setItem('filter_page','1');
        const apiUrl = localStorage.getItem('api_url');

        let data = new FormData();
        data.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        data.append('language', this.state.langKey);   
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: apiUrl+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({ reset_count: user_details.totalresets });
                var profile = new FormData();
                profile.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                profile.append('language', this.state.langKey);
                axios({
                    method: 'post',
                    url: this.state.api_url + 'webcheckboost',
                    data: profile,
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(res => {
                    if (res.data.status === "true") {
                        this.setState({
                            boost_cashpayment: res.data.boost_cashpayment,
                            boostStatus: 'activated',
                            boostCount: res.data.boost_count
                        });
                    } else {
                        this.setState({
                            boost_cashpayment: res.data.boost_cashpayment,
                            boostStatus: 'available',
                            boostCount: res.data.boost_count
                        });
                    }
                });

                this.setState({
                    user_details: user_details,
                });

                var date = new Date();
                var details = new FormData();
                details.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
                details.append('language', this.state.langKey);
                details.append('limit', 20);                 
                details.append('timestamp', date.getTime());
                        
                axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
                axios({
                    method: 'post',
                    url: apiUrl+'webgetpeople',
                    data: details,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    if(res.data.status === "false"){
                        this.setState({ nofind: true });
                    } else {
                        const dataa = res.data;
                        this.setState({
                            peopleDetails: dataa.peoples,
                            totalSlides: dataa.peoples.length,
                        })
                    }
                }).catch(error => {
                    this.props.history.push("/"); 
                });
            } else {
                this.setState({ loginpage: true });
            } 
        }).catch(error => {
            this.setState({ loginpage: true });
        });
    }

    handleSlideChange = (index) => {
        this.setState({
            currentSlideIndex: index,
            showNoDataPrev: index === 0,
            showNoDataNext: index === (this.state.totalSlides - 1)
        });
    }

    handleFilterOpenModal = () => {
        localStorage.setItem('seleted_filterreligion', "");
        localStorage.setItem('selected_filterlanguage', "");
        this.setState({ filtermodal: true });
    }

    handleFilterCloseModal = () => {
        this.setState({ filtermodal: false });
    }

    handlePremiumOpenModal = () => {
        this.setState({ premiummodal: true });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    handleBoostPlanOpenModal = () => {
        if(this.state.boost_cashpayment === '1') {
            this.handlePaymentPendingOpenModal();
        } else if(this.state.boostStatus === 'activated') {
            this.setState({ activatedBoostModel: true });
        } else if(this.state.user_details.boost_count > 0 && this.state.boostStatus === 'available') {
            this.handleBoostActivateOpenModal();
        } else if(this.state.user_details.boost_count === 0 && this.state.boostStatus === 'activated') {
            this.handleBoostActivateOpenModal();
        } else if(this.state.user_details.boost_count > 0 && this.state.boostStatus === 'activated') {
            this.handleBoostActivateOpenModal();
        } else {
            this.setState({ boostplanmodal: true });
        }
    }

    handleBoostPlanCloseModal = () => {
        this.setState({ boostplanmodal: false });
    }

    handleBoostActivateOpenModal = () => {
        this.setState({ boostactivatemodal: true });
    }

    handleBoostActivateCloseModal = () => {
        this.setState({ boostactivatemodal: false });
    }

    handleBoostPaymentPlanCloseModal = () => {
        this.setState({ boostpaymentplanmodal: false });
    }

    handleBoostPaymentPlanOpenModal = () => {
        this.setState({ boostpaymentplanmodal: true });
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    shutModal(tabId) {
        this.setState({
            [tabId]: false
        });
    }

    resetusers(){
        let errors = {};
        var payment = new FormData();
        payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        axios({
          method: 'post', 
          url: this.state.api_url+'resetusers',
          data: payment, 
          config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if (res.data.status === "true") {
                this.setState({
                    nofoundmodal: true,
                    reset_msg: 'Reset done successfully'
                });
                window.location.reload();
            }else{
                this.setState({
                    nofoundmodal: true,
                    reset_msg: 'No dislike users found'
                });
            }
        });
    }

    handleResetPlanOpenModal = () => {
        if(this.state.reset_count !== '' && this.state.reset_count !== null && this.state.reset_count === 0) {
            this.setState({
                nofoundmodal: true,
                reset_msg: 'You have completed all your reset count'
            });
        } else {
            this.setState({ resetplanmodal: true });
        }
    }

    render() {
        if (this.state.loginpage) {
            return <Redirect to="/" />;
        }

        if (this.state.nofind) {
            return <Redirect to="/nofind" />;
        }

        const settings = {
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            initialSlide: 1,
            focusOnSelect: true,
            autoplay: true,
            beforeChange: (current, next) => this.handleSlideChange(next),
        };
        const { showNoDataPrev, showNoDataNext, user_details } = this.state;
        const { t } = this.props;

        return (
            <>
                <section className='common_layout '>
                    <div>
                        <div className='header_layout'>
                            <div className='header_img'>
                                <img src={booster} alt="img" onClick={this.handleBoostPlanOpenModal} />
                                {this.state.user_details.premium_member === 'true' && this.state.user_details.plan_type !== "Kaba Silver" && (
                                    <img src={revert} alt="img" onClick={this.handleResetPlanOpenModal} className='revert_image' />
                                )}
                            </div>
                            <div className='header_title'>
                                <h4><Trans i18nKey="People Near You">People Near You</Trans></h4>
                            </div>
                            <div className='header_img' onClick={this.handleFilterOpenModal}>
                                <img src={filter} alt="img" className='filter_img'/>
                            </div>
                        </div>
                        {this.state.successMessage && (
                            <div className='whole_information'>
                                <div className={this.state.suc_cls}>
                                    {this.state.successMessage}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt_1'>
                        <Container>
                            <Row className='aligned_center'>
                                <Col md={7}>
                                    <div className='whole_people_card'>
                                        {showNoDataPrev && (
                                            <div className='nodata_prevs'>
                                                <p><Trans i18nKey="No more profiles">No more profiles</Trans></p>
                                            </div>
                                        )}
                                        <Slider {...settings} className={showNoDataPrev ? 'no-data-prevslider' : showNoDataNext ? 'no-data-nextslider' : ''}>
                                            {this.state.peopleDetails && this.state.peopleDetails.length > 0 && (
                                                this.state.peopleDetails.map((peopleDetails, index) => (
                                                    <div key={index} className='people_card people_first_card people_current_card'>
                                                        <div>
                                                            <img src={peopleDetails.images} alt="img" />
                                                        </div>
                                                        <div className="people_content">
                                                            <div>
                                                                <h4>{peopleDetails.user_name}{peopleDetails.show_age === 'false' && `, ${peopleDetails.age}`}</h4>
                                                                <div className='people_sub_content'>
                                                                    {peopleDetails.show_location === 'false' && (
                                                                        <>
                                                                            <img src={peoplelocation} alt="img" />
                                                                            <p>{peopleDetails.location}</p>
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <Link to={`/peopledetail/${peopleDetails.user_id}`}>
                                                                    <Button className='button_primary'><Trans i18nKey="INFO">INFO</Trans></Button>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </Slider>
                                        {showNoDataNext && (
                                            <div className='nodata_next'>
                                                <p><Trans i18nKey="No more profiles">No more profiles</Trans></p>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col md={5} className='people_card_rightside'>
                                    <div className='people_card_rightsidediv'>
                                        <div>
                                            <h4><Trans i18nKey="Connecting Hearts, Creating Bonds Meet New People Around You!">Connecting Hearts, Creating Bonds Meet New People Around You!</Trans></h4>
                                        </div>
                                        <div className='people_lottie_height'>
                                            <Lottie animationData={people} className='people_lottie_player' />
                                        </div>
                                        {this.state.user_details && this.state.user_details.premium_member === "false" && (
                                            <div className="join_premium">
                                                <Button className="button_primary" onClick={this.handlePremiumOpenModal}><Trans i18nKey="JOIN PREMIUM">JOIN PREMIUM</Trans></Button>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>

                <Modal isOpen={this.state.activatedBoostModel} toggle={this.shutModal.bind(this, 'activatedBoostModel')} className="modal_div joinplan_modal" >
                    <ModalBody className="religion_modal paymentsuccess_modal">
                        <div className=''>
                            <p><Trans i18nKey="Boost Activated Currently">Boost Activated Currently</Trans></p>
                        </div>
                    </ModalBody>
                </Modal>
                
                <Modal isOpen={this.state.resetplanmodal} toggle={this.shutModal.bind(this, 'resetplanmodal')} className="modal_div boostplan_modal" centered>
                    <ModalBody className="religion_modal">
                        <div className='boostplan_img'>
                            <img src={boost} alt="img" />
                        </div>
                        <div className='boostplan_content'>
                            <h4>{this.state.reset_count} <Trans i18nKey="Remaining">Remaining</Trans></h4>
                            <p><Trans i18nKey="Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.">Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.</Trans></p>
                        </div>
                    </ModalBody>
                    <ModalFooter className="forgot_button_plr boostplan_button">
                        <Button className='boostplan_cancelbtn' onClick={this.shutModal.bind(this, 'resetplanmodal')}>
                        <Trans i18nKey="CANCEL">CANCEL</Trans>
                        </Button>
                        <Button className='button_primary ' onClick={this.resetusers}>
                        <Trans i18nKey="Reset Users">Reset Users</Trans>
                        </Button>
                    </ModalFooter>
                </Modal>
                
                <Modal isOpen={this.state.nofoundmodal} toggle={this.shutModal.bind(this, 'nofoundmodal')} className="modal_div joinplan_modal" >
                    <ModalBody className="religion_modal paymentsuccess_modal">
                        <div className=''>
                            <p>{this.state.reset_msg}</p>
                        </div>
                    </ModalBody>
                </Modal>

                <Filter
                    showModal={this.state.filtermodal}
                    handleClose={this.handleFilterCloseModal}
                />

                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />

                <BoostPlan
                    showModal={this.state.boostplanmodal}
                    handleClose={this.handleBoostPlanCloseModal}
                />

                <BoostActivate
                    showModal={this.state.boostactivatemodal}
                    handleClose={this.handleBoostActivateCloseModal}
                />

                <BoostPaymentPlan
                    showModal={this.state.boostpaymentplanmodal}
                    handleClose={this.handleBoostPaymentPlanCloseModal}
                />

                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(withRouter(People));
